import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import firebaseConfig from "./firebaseConfig";
import {
  EMAIL_ALREADY_EXIST,
  INVALID_CREDENTIAL,
  INVALID_PASSWORD_FORMATE,
  USER_NOT_FOUND,
} from "./customErrorMessage";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const getFirebaseErrorMessage = (code) => {
  let message = "";
  switch (code) {
    case "auth/email-already-in-use":
      message = EMAIL_ALREADY_EXIST;
      break;
    case "auth/user-not-found":
      message = USER_NOT_FOUND;
      break;
    case "auth/invalid-credential":
      message = INVALID_CREDENTIAL;
      break;
    case "auth/weak-password":
      message = INVALID_PASSWORD_FORMATE;
      break;
    default:
      message = code;
  }
  return message;
};
